module.exports = __webpack_public_path__ + "media/images/icons8-exercise-e1bcff676b0dc358bdf9699dff74d55a.svg";